<!--
  Text / Photo 50:50 ("Tekst/Zdjęcie 50:50")

  Two-column section: overline, heading and rich-text body on the left; photo
  with centred label on the right. Max width 1200px.
-->
<template>
  <section class="relative flex w-full flex-col items-center justify-center overflow-x-hidden bg-white px-4 py-12 md:px-16 lg:py-16">
    <div class="mx-auto flex w-full min-w-0 max-w-[1200px] flex-col gap-8 lg:flex-row lg:items-center lg:gap-8">
      <!-- Left: text -->
      <div class="flex min-w-0 flex-1 flex-col gap-6">
        <div class="flex min-w-0 flex-col gap-1">
          <p
            v-if="overlineText"
            class="text-[14px] font-semibold uppercase leading-5 tracking-[1px]"
          >
            {{ overlineText }}
          </p>
          <h2
            class="break-words text-[32px] font-medium leading-10 tracking-[-0.64px] lg:text-[36px] lg:leading-[44px] lg:tracking-[-0.72px]"
          >
            {{ headingText }}
          </h2>
        </div>

        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
          v-if="bodyText"
          class="text-photo-5050-prose min-w-0 max-w-none overflow-x-hidden text-dark"
          v-html="bodyText"
        />
      </div>

      <!-- Right: photo -->
      <div class="relative min-w-0 flex-1">
        <div class="relative min-h-[280px] overflow-hidden rounded-[24px] bg-gray-200 md:min-h-[400px] lg:min-h-[460px]">
          <img
            v-if="photo"
            :src="photo"
            :alt="imageAlt || headingText"
            class="absolute inset-0 size-full object-cover"
          >

          <!-- Figma: brand tint #2EA8CF @ 80% over the photo -->
          <div
            aria-hidden="true"
            class="pointer-events-none absolute inset-0 bg-[#2EA8CF]/80"
          />

          <p
            v-if="imageOverlayText"
            class="absolute inset-0 flex items-center justify-center whitespace-pre-line px-6 text-center text-[20px] font-bold uppercase leading-7 tracking-[1px] text-white drop-shadow-md md:text-[24px] md:leading-8 lg:text-[28px] lg:leading-9"
          >
            {{ imageOverlayText }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  overlineText: { type: String, default: 'INSTYTUT GENOMIKI I MEDYCYNY MOLEKULARNEJ' },
  headingText: { type: String, default: 'Kim jesteśmy?' },
  bodyText: { type: String, default: '' },
  photo: { type: String, default: '' },
  imageAlt: { type: String, default: '' },
  imageOverlayText: { type: String, default: 'INSTYTUT GENOMIKI\nI MEDYCYNY MOLEKULARNEJ' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context: { type: String, default: null },
});
</script>

<style scoped>
.text-photo-5050-prose {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-photo-5050-prose :deep(p) {
  margin-bottom: 1.25rem;
}

.text-photo-5050-prose :deep(p:last-child) {
  margin-bottom: 0;
}

.text-photo-5050-prose :deep(strong) {
  font-weight: 700;
}
</style>
